import {
    defaultSelectedModel,
} from "../inventory-movements/state";

export default {
    show:{
        modal_component : false
    },
    loading: false,
    balance: 0,
    totalPay: 0,
    complete: false,
    selected_document: {},
    data: [],
    row_create: {
        id: null,
        document_id: "",
        payment_method_id: "",
        authorization_number: "",
        expiration_date: '',
        check_number: "",
        entity: "",
        value: "",
        value_change: 0,
        total_value: 0,
        new: true,
        index: null,
        quota: 1
    },
    selected_model: null,
    moneys: [],
    row_selected: {},
    paymentMethods :[],
    paymentMethodsSend :[],
    from_inventory_documents:false,
    from_accounting_documents:false,
};



// WEBPACK FOOTER //
// ./src/modules/payments-methods-modal/state.js